module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.eot?ecff11700aad0000cf3503f537d1df17";